"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT = void 0;
exports.NOT = {
    alias: 'NAO',
    description: 'retorna a negação da expressão',
    arg_names: ['expressão'],
    args_description: ['expressão booleana'],
};
